import './TopInfo.scss';

const TopInfo = () => {
    return (
        <div className="top-info">
            <div className="box-info">
                <img className="logo" src="/Assets/FotoDivisi/LogoAnantaNew.svg" alt="" />
                <p className="nama">Ananta</p>
            </div>
            <p className="copyright">© Prabangkara, Syandana, dan Wiskira OMB UMN 2023</p>
        </div>
    );
}
 
export default TopInfo;